import { useRef } from "react";
import {
  ICacheData,
  SaveToCacheFnType,
  GetFromCacheFnType,
} from "./CacheContext.types";

export const useCache = () => {
  const cacheRef = useRef<ICacheData>({});

  const saveToCache: SaveToCacheFnType = (key, data) =>
    (cacheRef.current[key] = data);

  const getFromCache: GetFromCacheFnType = (key) => {
    const data = cacheRef.current?.[key];

    if (Array.isArray(data)) {
      return [...data];
    }

    return data;
  };

  return {
    saveToCache,
    getFromCache,
  } as const;
};
